<template>
  <div 
    class="height-100 bg-cover-center"
    :style="styleSettings" 
    v-bind:class="{ 'bg-gradiant onair-logo-OP' : (this.$route.name === 'createapp' || this.$route.name === 'expire'  || this.$route.name === 'orderserviceNew' || this.$route.name === 'ordersuccessview'), 'vapptour': (!user.CoachmarksCompletedContentSection  || !user.CoachmarksCompletedDesignSection || !user.CoachmarksCompletedTemplateSelection)} ">
    <div :class="{landscapewarning : isValidForRotateImg}" style="display:none;">
      <div class="rotateimg">
        <img :src="rotateimg" alt="rotate-phone" />
        <div class="rotate-info">
        <h1>{{resource.str_rotate_device}}</h1> 
        <span>{{resource.str_not_support}}</span> 
        </div>
      </div>
    </div>
    <Loader v-show="loading"></Loader> 
    <transition :name="transitionName">
      <router-view v-if="requiredDataLoaded"></router-view>
    </transition>
    <image-gallery-dialog></image-gallery-dialog>
    <icon-gallery></icon-gallery>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ImageGalleryDialog from '@/components/Shared/ImageGallery/Dialog'
import IconGallery from '@/components/Shared/IconGallery'
import Loader from '@/components/Shared/Loader'
import * as Helper from '@/modules/helper/index'
import rotate from '@/assets/images/rotatephone.png'

export default {
  name: 'app',
  components: {
    ImageGalleryDialog,
    IconGallery,
    Loader
  },
  computed: {
    ...mapGetters([
      'loading',
      'domainSettings',
      'resource',
      'user'
    ]),
    styleSettings () {
      let a = (this.$route.name === 'login' || this.$route.name === 'forgotpassword')
        ? `background-image: url(${this.domainSettings.BackgroundImageLogin})`
        : (this.$route.name === 'createapp' || this.$route.name === 'expire' || this.$route.name === 'orderserviceNew' || this.$route.name === 'ordersuccessview') ? '' : `background-image: url(${this.domainSettings.BackgroundImageControlPanel})`
      return a
    },
    isValidForRotateImg () {
      return this.showRotateImg
    }
  },
  data () {
    return {
      requiredDataLoaded: false,
      transitionName: '',
      rotateimg: rotate,
      isFixed: false,
      showRotateImg: false
    }
  },
  methods: {
    ...mapActions([
      'populateDomainSettings',
      'loadResource'
    ]),
    async initApp () {
      this.requiredDataLoaded = false
      this.$showLoader()
      await Promise.all([
        this.populateDomainSettings(),
        this.loadResource()
      ])
      this.requiredDataLoaded = true
      this.$hideLoader()
    },
    isValidForViewPort () {
      if (this.user.Authenticated && this.$route.name !== 'login' && this.$route.name !== 'forgotpassword') {
        return true
      }
      return false
    },
    handleViewPort () {
      if (this.isValidForViewPort()) {
        if (!this.isFixed) {
          Helper.fixViewPortMetaTag()
          this.isFixed = true
        }
      } else {
        this.isFixed = false
        Helper.resetViewPortMetaTag()
      }
    },
    handleOrientation () {
      this.showRotateImg = false
      if (window.orientation >= 0 && this.user.Authenticated && this.$route.name !== 'login' && this.$route.name !== 'forgotpassword') {
        if (window.orientation === 0) {
          this.showRotateImg = true
        }
      }
    },
    attachOrientationEvent () {
      window.addEventListener('orientationchange', this.handleOrientation, false)
    }
  },
  created () {
    this.initApp()
    this.attachOrientationEvent()
  },
  watch: {
    '$route' (to, from) {
      this.handleOrientation()
      this.handleViewPort()
      if (from.fullPath === '/') {
        this.transitionName = ''
      } else if (to.name === 'createapp') {
        this.transitionName = 'slideRight1'
      } else {
        let backNavigation = false
        if (to.params.direction && to.params.direction === 'back') {
          backNavigation = true
        }
        this.transitionName = backNavigation ? 'slideRight1' : 'slideLeft1'
      }
    }
  }
}
</script>
<style>

.bg-cover-center {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.slideLeft1-enter-active,
.slideLeft1-leave-active {
  transition: all 1s ease-out;
}

.slideRight1-enter-active,
.slideRight1-leave-active {
  transition: all 1s ease-out;
}

.slideLeft1-enter {
  position: absolute;
  transform: translate(100%, 0);
}

.slideLeft1-leave-to {
  position: absolute;
  /* opacity: 0; */
  transform: translate(-100%, 0);
}

.slideRight1-enter {
  position: absolute;
  transform: translate(-100%, 0);
}

.slideRight1-leave-to {
  position: absolute;
  /* opacity: 0; */
  transform: translate(100%, 0);
}
.landscapewarning{
    display: flex !important;
    height: 100%;
    background-color: #3d9df0;
    color: white;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 5%;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
  }
  .rotateimg img{
    margin-bottom: 56px;
  }
.rotate-info h1{
  font-size: 4.5rem;
}
.rotate-info span{
  font-size: 3.9rem;
}
.bg-gradiant{
background: #42ffff;
background: -moz-linear-gradient(left,  #42ffff 0%, #0f5fff 100%);
background: -webkit-linear-gradient(left,  #42ffff 0%,#0f5fff 100%);
background: linear-gradient(to right,  #42ffff 0%,#0f5fff 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#42ffff', endColorstr='#0f5fff',GradientType=1 );
}
</style>



// WEBPACK FOOTER //
// src/App.vue